// @ts-nocheck
import { useState } from 'react';

import { ArrowRight, Check, SpinnerGap } from '@phosphor-icons/react';
import { Button, Input, Text, XStack, YStack } from 'tamagui';

type SubscribeFormProps = {
  variant?: 'default' | 'compact';
};

export function SubscribeForm({ variant = 'default' }: SubscribeFormProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();

    if (!email) {
      setStatus('error');
      setMessage('Email is required.');
      return;
    }
    if (!email.includes('@') || !email.includes('.')) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://waitlist-worker.romans-dev.workers.dev/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          product: 'torch',
          source: 'usetorch.dev',
          newsletter: true,
          ...(website ? { website } : {}),
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setMessage(data.message || "You're on the list!");
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.message || 'Could not join waitlist. Please try again.');
      }
    } catch {
      setStatus('error');
      setMessage('Connection failed. Check your network and try again.');
    }
  };

  const handleReset = () => {
    setStatus('idle');
    setMessage('');
    setEmail('');
  };

  if (status === 'success') {
    return (
      <YStack gap="$2" alignItems="center">
        <XStack
          alignItems="center"
          justifyContent="center"
          gap="$2"
          paddingVertical="$3"
          paddingHorizontal="$4"
          backgroundColor="$green2"
          borderRadius="$4"
          borderWidth={1}
          borderColor="$green7"
        >
          <Check size={18} color="var(--green9)" />
          <Text color="$color11" fontWeight="500">
            {message}
          </Text>
        </XStack>
        <Text
          fontSize={13}
          color="$color7"
          cursor="pointer"
          hoverStyle={{ color: '$color9' }}
          onPress={handleReset}
        >
          Submit another email
        </Text>
      </YStack>
    );
  }

  return (
    <YStack gap="$2" width="100%" maxWidth={variant === 'compact' ? 400 : 480}>
      <form onSubmit={handleSubmit}>
        <XStack
          gap="$2"
          flexDirection={variant === 'compact' ? 'column' : 'row'}
          $sm={{ flexDirection: 'column' } as any}
        >
          <Input
            flex={1}
            size="$5"
            placeholder="Enter your email"
            value={email}
            onChangeText={(val: string) => {
              setEmail(val);
              if (status === 'error') setStatus('idle');
            }}
            keyboardType="email-address"
            autoCapitalize="none"
            backgroundColor="$color2"
            borderColor={status === 'error' ? '$red8' : '$color5'}
            borderWidth={1}
            color="$color12"
            placeholderTextColor="$color8"
            focusStyle={{
              borderColor: '$accentBackground',
              outlineColor: '$accentBackground',
            }}
            hoverStyle={{
              borderColor: '$color6',
            }}
          />
          <Button
            size="$5"
            paddingHorizontal="$5"
            disabled={status === 'loading'}
            backgroundColor="$accentBackground"
            color="$accentColor"
            fontWeight="600"
            hoverStyle={{ opacity: 0.9, scale: 1.02 }}
            pressStyle={{ scale: 0.98 }}
            onPress={handleSubmit as any}
          >
            {status === 'loading' ? (
              <SpinnerGap size={18} color="var(--accentColor)" />
            ) : (
              <>
                <Text color="$accentColor" fontWeight="600">
                  Get Notified
                </Text>
                <ArrowRight size={16} color="var(--accentColor)" style={{ marginLeft: 4 }} />
              </>
            )}
          </Button>
        </XStack>
      </form>
      {/* Honeypot */}
      <input
        type="text"
        name="website"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0 }}
        tabIndex={-1}
        autoComplete="off"
      />
      {status === 'error' && (
        <XStack gap="$2" alignItems="center" justifyContent="center">
          <Text color="$red9" fontSize={13}>
            {message}
          </Text>
          <Text
            fontSize={13}
            color="$color7"
            cursor="pointer"
            hoverStyle={{ color: '$color9' }}
            onPress={handleSubmit}
            textDecorationLine="underline"
          >
            Try again
          </Text>
        </XStack>
      )}
      {variant === 'default' && (
        <Text fontSize={13} color="$color7" marginTop="$1" textAlign="center">
          Be the first to know when we launch. No spam, ever.
        </Text>
      )}
    </YStack>
  );
}
